var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-menu",
    {
      attrs: { "open-on-hover": "", "max-width": _vm.maxWidth },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "v-icon",
                _vm._g({ attrs: { small: _vm.small, color: _vm.color } }, on),
                [_vm._v("mdi-help-circle-outline")]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "cards-body",
        {
          attrs: {
            "hide-title": _vm.hideTitle,
            title: _vm.title,
            "no-btn-create": "",
          },
        },
        [_c("span", { domProps: { innerHTML: _vm._s(_vm.text) } })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }